import React, {Component} from 'react';
import LoginThirdBtn from "../LoginThirdBtn";
import WxLoginCode from "../LoginWechatCode";
import './index.css'

class LoginWechat extends Component {
    constructor(props) {
        super(props);
        this.state={
            ...props.customLoginConfig
        }
    }
    render() {
        const { changeContModePage, isCorp, customLoginConfig} = this.props;
        const modeBtnShow={
            dingdingShow:true,
            workWechatShow:true,
            qyWechatShow:true,
            feishuShow:true,
            qyzjWechatShow:true,
            wechatShow:false,
            LoginAccountPasswordShow: true,
            LoginCodeShow: true,
            ssoShow: true,
        }
        return (
            <div className="LoginWechat">
                <div className="loginContentBox">
                    <div className="title">
                        {React.language('account.signin.wechat1')}
                    </div>
                    <WxLoginCode />
                </div>
                <LoginThirdBtn customLoginConfig={customLoginConfig} isCorp={isCorp} modeBtnShow={modeBtnShow} changeContModePage={changeContModePage} />
            </div>
        );
    }
}

export default LoginWechat;